import { shopperApprovedReviews } from '@/scripts/shopperApproved';
import styled from 'styled-components';
import Screen from 'src/styles/Themes/Screen';
import Script from 'next/script';

export const ShopperApprovedReviews = () => {
    return (
        <Wrapper>
            <Content className="shopperapproved_widget sa_rotate sa_horizontal 2 sa_bgWhite sa_colorBlack sa_borderGray sa_rounded sa_jMy sa_fixed sa_showlinks sa_count2 sa_large sa_showdate" />
            <Logo>
                <a
                    aria-label="TripShock.com certificate URL"
                    title="Reviews"
                    className="sa_footer"
                    href="https://www.shopperapproved.com/reviews/TripShock.com"
                    target="_blank"
                    rel="nofollow noreferrer"
                >
                    <img
                        className="sa_widget_footer"
                        style={{ border: 0 }}
                        alt="TripShock.com widget logo"
                        src="https://www.shopperapproved.com/widgets/widgetfooter-darklogo.png"
                    />
                </a>
            </Logo>
            <Script
                id="ShopperApprovedReviews"
                type="text/javascript"
                dangerouslySetInnerHTML={{
                    __html: shopperApprovedReviews,
                }}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    margin-top: 20px;

    ${Screen.desktop} {
        width: 100%;
        max-width: 568px;
    }
`;

const Content = styled.div`
    min-height: 100px;
`;

const Logo = styled.div`
    text-align: right;

    ${Screen.desktop} {
    }
`;
